import { gql } from 'apollo-client-ppc';

export const commonPaymentMethods = gql`
  fragment paymentMethodFields on PaymentMethod {
    id
    paymentIssue
    type
    default
    ... on CreditCard {
      card {
        expirationMonth
        expirationYear
        last4Numbers
        brand
        cardHolderName
      }
    }
    ... on PaymentOnTerms {
      terms {
        invoiceDueDays
        payOnStatement
      }
      totalCreditLimit
      paymentMethod
    }
    ... on PayPal {
      payPal {
        name
        email
      }
    }
    ... on Ach {
      ach {
        bankName
        last4
      }
    }
  }
`;

export const commonCommerceAddress = gql`
  fragment commerceAddressFields on CommerceAddress {
    id
    name
    addressLine1
    addressLine2
    city
    state
    country
    postcode
    taxId
    taxIds {
      id
      label
      taxExempt
      metadata {
        vatStatus
      }
    }
    taxLabels {
      region
      taxIdLabels {
        description
        displayName
        type
        metadata {
          type
          labels {
            default
            label
            vatStatus
          }
        }
      }
    }
    taxExempt
  }
`;
